import CourseCards from "../../components/course-cards";
import FormController from "./form-controller";
import HeroVideo from "./hero-video";

export default class PageModule {
    constructor() {
        this.initFormController();
        this.initHeroVideo();
        this.initCourseRecommendations();
    }

    initFormController() {
        new FormController();
    }

    initHeroVideo() {
        new HeroVideo();
    }

    initCourseRecommendations() {
        const $section = document.querySelector('.section.-recommendations');

        if (!$section) {
            return;
        }

        new CourseCards($section.querySelectorAll('.course-card'));
    }
}